import { FileDesc, Upload } from '@wellesley/openapi'
import { MediaUpload } from '../../types'
import getExtensionFromPath from 'helpers/getExtensionFromPath'
import isDefaultPreview from '../isDefaultPreview'

export const isUpload = (item: MediaUpload): item is Upload =>
  'uploadId' in item &&
  'files' in item &&
  Array.isArray(item.files) &&
  !('upload' in item)

export const mapUpload = (item: MediaUpload): Upload => {
  if (isUpload(item)) {
    return item
  }

  const isDefaultVideoPreview = isDefaultPreview(item.preview)
  const isNotSupportedVideo =
    item.type === 'VIDEO' && !item.duration && isDefaultVideoPreview

  return {
    ...item,
    userId: '',
    size: 0,
    files: [
      {
        uri: item.preview,
        size: 1,
        extension: getExtensionFromPath(item.meta?.name || ''),
        meta: {
          width: item.sizes.width,
          height: item.sizes.height,
          duration: item.duration,
        },
      },
      isNotSupportedVideo && {
        uri: item.preview,
        size: 1,
        extension: 'png',
        meta: {
          width: item.sizes.width,
          height: item.sizes.height,
          duration: item.duration,
        },
      },
    ].filter(Boolean) as FileDesc[],
    uploadType: item.type,
    uploadId: item.id,
    meta: item.meta,
    tags: [],
    createdAt: '',
    updatedAt: '',
  }
}
